import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Create,
  useForm,
} from "@pankod/refine-antd";
import { IPlansFamily } from "interfaces";
import { PlansFamilyForm } from "components/forms";

export const PlansFamilyCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IPlansFamily>();
  return (
    <Create saveButtonProps={saveButtonProps}>
      <PlansFamilyForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Create>
  );
};
